const siteMetadata = {
  description: 'Leader in New and Used John Deere Equipment',
  image: '/hutson-inc-og.jpg',
  siteUrl: 'https://www.hutsoninc.com',
  title: 'Hutson Inc',
  titleFormal: 'Hutson, Inc.',
  // Social media
  facebookUrl: 'https://www.facebook.com/hutsoninc/',
  instagramUrl: 'https://www.instagram.com/hutson_inc._/',
  linkedinUrl: 'https://www.linkedin.com/company/hutsoninc/',
  twitterUrl: 'https://twitter.com/Hutson_Inc',
  twitterUsername: '@Hutson_Inc',
  youtubeUrl: 'https://www.youtube.com/@hutsoninc',
}

module.exports = siteMetadata
